import React from 'react';
import PropTypes from 'prop-types';

import AlphaNumericInput from '../AlphaNumericInput';
import FormikField from './FormikField';

const FormikAlphaNumericInputField = ({ field, form, useSpecialCharacters, ...other }) => (
  <FormikField field={field} form={form}>
    <AlphaNumericInput
      onChange={({ target }) => form.setFieldValue(field.name, target.value, true)}
      useSpecialCharacters={useSpecialCharacters}
      {...other}
    />
  </FormikField>
);

FormikAlphaNumericInputField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
  }).isRequired,
  useSpecialCharacters: PropTypes.bool,
  other: PropTypes.object,
};

FormikAlphaNumericInputField.defaultProps = {
  useSpecialCharacters: false,
  other: null,
};

export default FormikAlphaNumericInputField;
